import React from 'react';
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import { Box, Grid } from '@mui/material';

import HomeNavButton from '../buttons/HomeNavButton';


const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL

const Homepage = () => {

    const navigate = useNavigate();

    return (
        <Container
            component="main"
            maxWidth="xs"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                top: '15vh', // Position 25% down from the top
                left: '50%', // Center horizontally
                transform: 'translateX(-50%)', // Center horizontally
                gap: '16px', // Spacing between elements
            }}>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ mt: 4, mb: 6, p: 1 }}>
                <img
                    loading="lazy"
                    src={`${IMAGE_URL}headers/ASXMarioKart.png`}
                    style={{ width: "95%", maxWidth: "300px" }}
                    alt="ASX Mario Kart Title"
                />
            </Box>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <Grid container spacing={3} sx={{ maxWidth: '500px' }}>
                    <Grid item xs={6}>
                        <HomeNavButton imgPath="navigation/Stats.png" imgWidth='80px' atlName="Stats" targetPage="/stats" navigate={navigate} />
                    </Grid>
                    <Grid item xs={6}>
                        <HomeNavButton imgPath="navigation/Roster.png" imgWidth='90px' atlName="Roster" targetPage="/roster" navigate={navigate} />
                    </Grid>
                    <Grid item xs={6}>
                        <HomeNavButton imgPath="navigation/GrandPrix.png" imgWidth='130px' atlName="Grand Prix" targetPage="/grandprix" navigate={navigate} />
                    </Grid>
                    <Grid item xs={6}>
                        <HomeNavButton imgPath="navigation/RaceEntry.png" imgWidth='130px' atlName="Race Entry" targetPage="/raceentry" navigate={navigate} />
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}

export default Homepage;
